// component
import BidPurchaseList from './bid-purchase-list/bid-purchase-list.vue';
export default [
  {
    path: 'list',
    name: 'bidPurchaseList',
    component: BidPurchaseList,
    meta: {
      title: '竞价采购标的',
      breadCrumbShowIndexArr: [0, 2]
    }
  }
];

